import { FC } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
} from '@chakra-ui/react';
import { AddIconButton } from 'components/atoms/AddIconButton';
import { MinusIconButton } from 'components/atoms/MinusIconButton';
import { EditHookReturnType } from '../../../types';
import { PlaneTextInput, SelectTextInput } from '../../../../Forms';

type Props = EditHookReturnType['form'] & {
  mode: '登録' | '更新';
  handleConfirm: () => void;
  onOpenModalDelete: () => void;
  onAppend: () => void;
  onRemove: (index: number) => void;
  controlledFields: { id: number | undefined; version: string }[];
  componentList: { id: number | undefined; name: string }[];
};

export const EnvironmentRegistrationInputModalView: FC<Props> = ({
  mode,
  register,
  formState,
  handleConfirm,
  onOpenModalDelete,
  onAppend,
  onRemove,
  controlledFields,
  componentList,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">環境の{mode}</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl isRequired isInvalid={!!formState.errors.name}>
          <FormLabel>環境名</FormLabel>
          <PlaneTextInput name="name" register={register} />
          <FormErrorMessage>{formState.errors.name?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.components}>
          {controlledFields.map((field, index) => (
            <Stack key={index.toString()}>
              <HStack>
                <FormLabel>コンポーネント: {index + 1}</FormLabel>
                {mode === '登録' && (
                  <MinusIconButton label="" onClick={() => onRemove(index)} />
                )}
              </HStack>
              <Stack
                pointerEvents={(mode === '登録' && 'auto') || 'none'}
                pl="5"
              >
                <FormLabel>コンポーネント名</FormLabel>
                <Stack p={2}>
                  <Stack bg={(mode === '登録' && 'auto') || '#ccc'}>
                    <SelectTextInput
                      list={componentList}
                      name={`components.${index}.id`}
                      register={register}
                    />
                    <FormErrorMessage>
                      {formState.errors.components?.[index]?.id?.message}
                    </FormErrorMessage>
                  </Stack>
                  <FormLabel>バージョン</FormLabel>
                  <Stack bg={(mode === '登録' && 'auto') || '#ccc'}>
                    <PlaneTextInput
                      name={`components.${index}.version`}
                      register={register}
                    />
                    <FormErrorMessage>
                      {formState.errors.components?.[index]?.version?.message}
                    </FormErrorMessage>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          ))}
        </FormControl>
        {/* 環境の追加 */}
        <Stack>
          {mode === '登録' && <AddIconButton label="" onClick={onAppend} />}
        </Stack>
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Stack alignItems="center" spacing="24px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          onClick={handleConfirm}
          isDisabled={!formState.isValid}
        >
          確認
        </Button>
        {mode === '更新' && (
          <Button
            variant="link"
            colorScheme="blackAlpha"
            onClick={onOpenModalDelete}
          >
            この環境を削除
          </Button>
        )}
      </Stack>
    </ModalFooter>
  </ModalContent>
);
